import Table from 'react-bootstrap/Table';
import {useParams, useLocation} from 'react-router-dom';
import {useEffect, useState} from "react";
import {WashnetBackend} from "../services/WashnetBackend";
import {ReportHeader} from '../components/ReportHeader';
import {AlarmDetailRequest, AlarmDetailResponse} from "../models/reports"
import {ModalShowMessage} from "../admin/ModalShowMessage"
import {ReportParams} from "../models/reports";
import {Data} from "../components/Data"
import {unixTimeToTimeString, unixTimeToDateString} from "../util";

export interface AlarmDetailProps {
    backend: WashnetBackend
}

export const ReportAlarmDetail: React.FC<AlarmDetailProps> = (props: AlarmDetailProps) => {

    const {customerId, siteId, systemId, machineId} = useParams();
    const [alarmDetail, setAlarmDetail] = useState<AlarmDetailResponse>();

    const state:ReportParams = useLocation().state;

    useEffect(() => {
        // Make sure we have these IDs.
        if (customerId === undefined || siteId === undefined || systemId === undefined || machineId === undefined) {
            console.log("customerId, siteId, systemId or machineId is undefined");
            return;
        }

        // Outgoing to backend.
        let params: AlarmDetailRequest = {
            customerId: customerId,
            siteId: siteId,
            systemId: systemId,
            machineId: machineId,
            startDate: state.startDate,
            endDate: state.endDate
        }

        props.backend.getAlarmDetailReport(params)
        .then((response: AlarmDetailResponse) => {
            setAlarmDetail(response);
        })
        .catch((error) => {
            setAlertMessage(error.message);
            setShowAlert(true);
        })

    }, [customerId, siteId, systemId, machineId]);

    ///////////////////////////////////
    // For the alert message
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    const handleCloseMessage = () => {
        setShowAlert(false);
    }

    return (
        <div>
            <ReportHeader title="Alarm Detail" machineName={state.machineName} startDate={state.startDate} endDate={state.endDate} timezone={state.timezone} />

            <Table striped bordered hover size="sm">
                <thead>
                    <tr>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Machine</th>
                    <th>Alarm</th>
                    <th>Item</th>
                    <th>Formula</th>
                    <th>Customer</th>
                    </tr>
                </thead>
                <tbody>
                    {
                    alarmDetail !== undefined &&
                    <>
                        {
                        alarmDetail.response.map((item, j) =>
                            <tr key={j.toString()}>
                            <td>{unixTimeToDateString(item.time, false)}</td>
                            <td>{unixTimeToTimeString(item.time, true, state.timezone.toString())}</td>
                            <td><Data value={item.machineName}/></td>
                            <td><Data value={item.alarm}/></td>
                            <td><Data value={item.item}/></td>
                            <td><Data value={item.formula}/></td>
                            <td><Data value={item.customerName}/></td>
                            </tr>
                        )
                        }
                    </>
                    }
                </tbody>
            </Table>
            <hr/>

            {/* Modal to show message. */}
            <ModalShowMessage show={showAlert}
                message={alertMessage}
                variant="danger"
                handleClose={handleCloseMessage}
            />
        </div>
    );
}
